import { render, staticRenderFns } from "./CFooter.vue?vue&type=template&id=2e22d1f8&scoped=true&"
import script from "./CFooter.vue?vue&type=script&lang=js&"
export * from "./CFooter.vue?vue&type=script&lang=js&"
import style0 from "./CFooter.vue?vue&type=style&index=0&id=2e22d1f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22d1f8",
  null
  
)

export default component.exports